import { Link } from "react-router-dom";
import InlineSpinner from "./buttonSpinner";

const Button = ({ buttonText, bgColor, width, destination, loading, buttonRole, handleClick, disabled }) => {
  return (
    <div>
      {buttonRole === "submit" ? (
        <button
          type="submit"
          disabled={loading || disabled}
          onClick={handleClick}
          className={`${bgColor ? bgColor : "bg-[#1DA1F2] text-white text-sm"} px-6 py-4 rounded-sm
            ${(loading || disabled) ? "cursor-not-allowed opacity-10" : ""}`}
        >
          {loading ? (
            <div className="flex items-end">
              <InlineSpinner />
            </div>
          ) : (
            <div>
              <span>{buttonText}</span>
            </div>
          )}
        </button>
      ) : (
        <button
          className={`bg-[#1DA1F2] text-white text-sm px-6 py-4 rounded-sm ${width}`}
        >
          <Link to={destination}>{buttonText}</Link>
        </button>
      )}
    </div>
  );
};

export default Button;
